import { useNavigate, useParams } from "react-router-dom";
import { SchedulePage as SchedulePageView } from "@/components/SchedulePage";

export function SchedulePage() {
  const navigate = useNavigate();
  const { scheduleId } = useParams<{ scheduleId: string }>();

  if (!scheduleId) return null;

  return (
    <SchedulePageView
      scheduleId={scheduleId}
      onBack={() => navigate("/schedules")}
      onEditSchedule={(id) => navigate(`/schedules/${id}/edit`)}
      onInvoiceClick={(id) => navigate(`/invoices/${id}`)}
      onCustomerClick={(id) => navigate(`/customers/${id}`)}
    />
  );
}
